import React, { FC } from 'react'
import styled from 'styled-components'
import MenuPrivate from "src/components/Common/MenuPrivate";

const HeaderWrapper = styled.header``

const HeaderPrivate: FC = () => (
  <HeaderWrapper>
    <MenuPrivate />
  </HeaderWrapper>
)

export default HeaderPrivate
